/* eslint-disable prettier/prettier */
import styled from 'styled-components';

const TitleSection = styled.section`
  align-items: center;
  color: ${({ color }) => color || '#36395A'};
  display: flex;
  flex-direction: column;
  font-family: "Inter UI";
  font-size: 20px;
  font-style: normal;
  font-weight: bold;
  line-height: 28px;
  margin: 16px 0px;
  text-align: center;
`;

export default TitleSection;
